import { render, staticRenderFns } from "./MobileSelector.vue?vue&type=template&id=4500ed90&"
import script from "./MobileSelector.vue?vue&type=script&lang=ts&"
export * from "./MobileSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MobileSelector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports